import { Item } from "./item";
import settings from "./synced-settings";

// define item types
export const CONTAINER_TYPES = ["list", "period", "label", "layout"];
export const ORDINARY_TYPES = ["task", "note"];
export const ITEM_TYPES = [...CONTAINER_TYPES, ...ORDINARY_TYPES];

const rootNames = {
  list: "Listy",
  label: "Etykiety",
  period: "Własne przedziały czasowe",
  layout: "Własne widoki",
};

export function seedItems(pouchDB) {
  const result = [
    {
      _id: "root",
      name: "Root",
      type: "root",
      icon: "account_tree",
      // actually we'd like to allow reordering but forbid adding
      readOnly: true,
      allowedChildren: [],
      childRel: REL_ELEM,
    },
    {
      _id: defaultContainerID(REL_ELEM),
      name: `Rzeczy bez listy`,
      type: "default",
      icon: "playlist_remove",
      undeletable: true,
      noMigration: true,
      childRel: REL_NO_PARENT,
      clearRelation: REL_ELEM,
      [REL_ELEM]: { key: "root" },
    },
    {
      _id: "notepad",
      name: "Notatnik",
      type: "notepad",
      icon: "border_color",
      readOnly: true,
      noMigration: true,
      undeletable: true,
      childRel: REL_ELEM,
      [REL_ELEM]: { key: "root" },
    },
  ];
  for (let i = 0; i < CONTAINER_TYPES.length; i++) {
    const type = CONTAINER_TYPES[i];
    result.push({
      _id: "root:" + type,
      name: rootNames[type],
      type: "root",
      readOnly: true,
      childRel: REL_ELEM,
      allowedChildren: [type],
      [REL_ELEM]: { key: "root", seq: `${i}` },
    });
  }
  for (let i = 0; i < DATE_UNITS.length; i++) {
    const unit = DATE_UNITS[i];
    result.push({
      _id: unit + "s",
      name: unit + "s",
      type: "dateUnit",
      readOnly: true,
      childRel: REL_ELEM,
      allowedChildren: [unit],
      [REL_ELEM]: { key: "calendar", seq: `${i}` },
    });
  }

  return result;
}

export function generateDateItem(key, cache, db) {
  const keyParts = key.split(":");
  const doc = {
    _id: key,
    name: keyParts[1],
    type: "date",
    readOnly: true,
    childRel: REL_PLAN,
  };
  return new Item(doc, cache, db);
}

function allowedChildTypes(item) {
  if (!item) return ["note", "task"];
  if (item.allowedChildren) return item.allowedChildren;
  if (item.type === "list" && settings.nestedLists) {
    return ["list", ...ORDINARY_TYPES];
  }
  if (item.type === "layout" || item.type === "board") {
    return [];
  }
  return ORDINARY_TYPES;
}
export function allowedChildInfo(parent) {
  return allowedChildTypes(parent).map((t) => ({ type: t, icon: typeIconMapping[t] }));
}

export function supportedViews(item) {
  if (item.supportedViews) return item.supportedViews;
  switch (item.type) {
    case "layout":
      return ["board"];
    case "root":
    case "calendar":
      return ["horizontal"];
    default:
      return ["simple", "horizontal"];
  }
}

// TODO zrobić z tego enuma czy coś
export const ORDRD = "ordered";
export const MULTI = "multiParent";
export const NO_PARENT = "noParent";

// define item relations
export const REL_PLAN = "plannedFor_1";
export const REL_ELEM = "subtaskOf_1";
export const REL_LABL = "labels_1";
// Special pseudo-relation to keep indexes of items that have no parent for
// each ordered relation. Search for `defaultContainerID` to see how it's used.
export const REL_NO_PARENT = "no-parent";

export const RELATIONS = [REL_PLAN, REL_ELEM, REL_LABL];
export const RELATION_CONFIG = {
  [REL_ELEM]: ORDRD,
  [REL_PLAN]: ORDRD,
  [REL_LABL]: MULTI,
  [REL_NO_PARENT]: NO_PARENT,
};

export const orderedRelations = RELATIONS.filter(
  (relation) => RELATION_CONFIG[relation] === ORDRD,
);

export const multiRelations = RELATIONS.filter(
  (relation) => RELATION_CONFIG[relation] === MULTI,
);

export function getRelationForType(type) {
  switch (type) {
    case "period":
      return REL_PLAN;
    case "label":
      return REL_LABL;
    default:
      return REL_ELEM;
  }
}

export const DATE_UNITS = ["day", "week", "month"];

export const typeIconMapping = {
  root: "view_week",
  list: "format_list_bulleted",
  period: "calendar_today",
  label: "label_outline",
  note: "notes",
  task: "check_box",
  goal: "flag",
  date: "today",
  dateUnit: "calendar_today",
  calendar: "event_note",
  separator: "horizontal_rule",
  layout: "dashboard",
};

function getAncestorIds(item) {
  const result = [item._id];
  while (item && item[REL_ELEM] && (item = item.cache.get(item[REL_ELEM].key))) {
    result.push(item._id);
  }
  return result;
}

function detectCycle(target, items) {
  const targetAncestorIDs = getAncestorIds(target);
  for (const id of items.map((item) => item._id)) {
    if (targetAncestorIDs.includes(id)) {
      return true;
    }
  }
  return false;
}

export function insertAllowed(target, items) {
  for (const item of items) {
    if (!allowedChildTypes(target).includes(item.type)) {
      alert(`Wrong type: cannot insert ${item.type} into ${target.type}`);
      return false;
    }
  }
  if (detectCycle(target, items)) {
    alert("Cannot insert item into itself!");
    return false;
  }
  return true;
}

export const defaultListID = defaultContainerID(REL_ELEM);

export function defaultContainerID(relation) {
  return "null:" + relation;
}
